import React from 'react';

import ReturnToMerchant from '../../../shared/ReturnToMerchant';
import Support from '../../../shared/Support';
import approved from '../../../../lib/images/approved_text.svg';
import checkmark from '../../../../lib/images/green_checkmark.svg';
import { borrowerPortalUrl } from '../../../../lib/constants/SiteVariables';

export default function Default({ merchant }) {
  return (
    <>
      <div className="text-xl text-navy-blue font-avenir-black">
        You're good to go!
      </div>
      <p className="mt-1 mb-3 text-dark-gray">We told you it would be easy</p>
      <div className="mt-3 flex flex-col items-center">
        <img alt="Green Checkmark" src={checkmark} className="h-12 w-12" />
        <img alt="Approved Text" src={approved} className="w-1/2 my-3" />
      </div>
      <div className="mx-auto max-w-[400px] leading-7">
        <p>
          Simply choose
          <strong className="font-avenir-medium mx-1">Credit Key</strong>at
          checkout.
        </p>
        <p>
          Access your account at
          <a
            className="font-avenir-medium ml-1 text-primary-blue"
            target="_blank"
            href={borrowerPortalUrl}
            rel="noreferrer"
          >
            www.creditkey.com
          </a>
        </p>
      </div>

      <ReturnToMerchant merchant={merchant} />
      <Support />
    </>
  );
}
